module.exports = __webpack_public_path__ + "img/2024-03.69f6a25c.jpg";